import { exploreCategoryQueryLabel, type ChatExploreCategoryKey } from 'tripPlanner/config/exploreCategories'
import type { UseExploreItemsParams, UseExploreNearbyItemsParams } from 'tripPlanner/hooks/api/exploreParams'
import type { GeoPoint } from 'tripPlanner/types/placeAndDateTime'
import { buildExploreQuery } from './explorePlaces'
import { EXPLORE_NEARBY_LIMIT, EXPLORE_RESTRICT_RADIUS_METRES } from './explorePlacesConstants'

/** The stop half of a stop search; the category is chosen separately on each surface. */
export interface StopExploreSearch {
  queryText: string
  coordinates: GeoPoint
}

export interface StopExploreParams {
  explore: UseExploreItemsParams
  nearby: UseExploreNearbyItemsParams
}

/**
 * The drawer's search and the map's handoff of it must produce byte-identical params, or React
 * Query treats them as different lists and the handoff silently re-queries Google. Built in one
 * place so that cannot drift. The nearby call omits `radius` deliberately — it is part of the key,
 * and the route already defaults to the same bound.
 */
export function buildStopExploreParams(
  categoryKey: ChatExploreCategoryKey,
  { queryText, coordinates }: StopExploreSearch,
): StopExploreParams {
  const locationBias: [number, number] = [coordinates.lat, coordinates.lng]

  return {
    explore: {
      query: buildExploreQuery(exploreCategoryQueryLabel(categoryKey), queryText),
      locationBias,
      restrictRadius: EXPLORE_RESTRICT_RADIUS_METRES,
    },
    nearby: { location: locationBias, limit: EXPLORE_NEARBY_LIMIT },
  }
}
